export default "__VITE_ASSET__IRHx7AYs__"